angular.module('bmsApp.accounting').controller('InvoiceIndexCustomerInvoiceTableCtrl', function ($scope,
																								   $filter,
																								   ngTableParams) {
	tableParams = {
		page: $scope.customerInvoices.length,
		sorting: {invoice_number: 'desc'}
	};

	tableOptions = {
		total: 0, // length of data
		counts: null,
		getData: function ($defer, params) {
			// reset array keys so that $filter will order
			var invoices = _.compact($scope.customerInvoices);

			params.total(invoices.length);
			$defer.resolve($filter('orderBy')(invoices, params.orderBy()[0]));
		}
	};

	$scope.customerInvoicesTable = new ngTableParams(tableParams, tableOptions);
});
